module.exports = __webpack_public_path__ + "img/British Indian Ocean Territory (Chagos Archipelago).e95a4c9a.svg";